module.exports = __webpack_public_path__ + "static/media/brochure-footer-tire-tracks.12cfd82f.webp";